"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var shallowequal_1 = __importDefault(require("shallowequal"));

var useMemo_1 = __importDefault(require("rc-util/lib/hooks/useMemo"));

function useValueTexts(value, _ref) {
  var formatList = _ref.formatList,
      generateConfig = _ref.generateConfig,
      locale = _ref.locale;
  return useMemo_1.default(function () {
    if (!value) {
      return [''];
    }

    return formatList.map(function (subFormat) {
      return generateConfig.locale.format(locale.locale, value, subFormat);
    });
  }, [value, formatList], function (prev, next) {
    return prev[0] !== next[0] || !shallowequal_1.default(prev[1], next[1]);
  });
}

exports.default = useValueTexts;